module.exports = __webpack_public_path__ + "img/ReactionsList.74a35a6c.png";